import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const ModalBody = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: ${getPurpurSpacing('400')};
`;

export const PreviewModalBody = styled(ModalBody)`
    margin-bottom: ${getPurpurSpacing('1000')};
`;

export const CardsList = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: ${getPurpurSpacing('200')};
`;

export const Form = styled(CardsList).attrs({ as: 'form' })``;
